module.exports = __webpack_public_path__ + "media/images/bondform_bearhead5-94c10743ffab67117a9a21bcbc34ed4c.gif";